import Choice from './origin-data-choice.vue';
import OriginData from './origin-data.vue';
import OriginSelect from './origin-select.vue';
import OriginSelectTigger from './origin-select-trigger.vue';
import Dependencias from './dependencia/dependencias.vue';
import FlexSetting from './flex-setting.vue';
import ListForms from './list-forms.vue';
import Actions from './actions.vue';
import ActionSubForm from './ActionSubForm.vue';
import InformativeList from './informative-list.vue';
import MoveQuestion from './Move-page.vue';

export const Modals = {
	Choice,
	OriginData,
	OriginSelect,
	OriginSelectTigger,
	Dependencias,
	FlexSetting,
	ListForms,
	Actions,
    ActionSubForm,
	InformativeList,
	MoveQuestion
}
